const ChevronDown = ({ stroke = '#181818' }: { stroke?: string }) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="trailing-icon">
        <path
          id="Icon"
          d="M6 7.875L9 10.875L12 7.875"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export default ChevronDown;
